// modules/Battle/BattleUILayout.js
// 战斗UI布局模块 - 负责创建UI布局和背景

export default class BattleUILayout {
    constructor(scene) {
        this.scene = scene;
        this.elements = {
            menu: {},
            messages: {}
        };
    }
    
    /**
     * 创建战斗背景
     */
    createBattleBackground() {
        const screenHeight = this.scene.cameras.main.height;
        const screenWidth = this.scene.cameras.main.width;
        
        // 底部菜单背景
        this.elements.menu.background = this.scene.add.graphics();
        this.elements.menu.background.fillStyle(0x000000, 0.85);
        this.elements.menu.background.fillRect(0, screenHeight - 100, screenWidth, 100);
        
        this.elements.menu.border = this.scene.add.graphics();
        this.elements.menu.border.lineStyle(2, 0x4a4a4a, 1);
        this.elements.menu.border.strokeRect(0, screenHeight - 100, screenWidth, 100);
    }
    
    /**
     * 创建消息区域
     */
    createMessageArea() {
        const screenHeight = this.scene.cameras.main.height;
        const screenWidth = this.scene.cameras.main.width;
        
        // 消息区域支持多行显示，从底部向上排列
        // 设置文本位置从底部开始，使用左上角对齐以便多行文本向上扩展
        this.elements.messages.text = this.scene.add.text(
            20,
            screenHeight - 90, // 从底部菜单上方开始，留出更多空间
            '选择你的行动',
            {
                fontSize: '16px',
                fill: '#ffff00',
                fontFamily: 'monospace',
                backgroundColor: '#000000',
                padding: { left: 10, right: 10, top: 5, bottom: 5 },
                wordWrap: { width: screenWidth - 60 }, // 支持自动换行
                align: 'left' // 左对齐，多行向上扩展
            }
        ).setOrigin(0, 1); // 设置原点为左下角，文本向上扩展
    }
    
    /**
     * 获取菜单元素
     * @returns {Object} 菜单元素
     */
    getMenuElements() {
        return this.elements.menu;
    }
    
    /**
     * 获取消息元素
     * @returns {Object} 消息元素
     */
    getMessageElements() {
        return this.elements.messages;
    }
}

